export const blockIconsCommonactionsLanguageNew = (
	<span className='material-symbols-outlined'>language</span>
);
